import { Link } from "react-router-dom";
import { AlertOctagon } from "lucide-react";
import { useGuard } from "../guard/GuardContext";
import { shortDate } from "../../lib/api";

export const WebhookAlertBanner = () => {
  const { st } = useGuard();
  const a = st?.webhook_alert;
  if (!a) return null;
  return (
    <Link to="/app/monitor" className="flex items-center gap-3 mb-4 px-4 py-2.5 border border-[#FF003C]/60 bg-[#FF003C]/[0.08] hover:bg-[#FF003C]/[0.14] transition-colors animate-pulse" data-testid="webhook-alert-banner">
      <AlertOctagon className="w-4 h-4 text-[#FF6B8A] shrink-0" />
      <span className="text-sm flex-1"><b className="text-[#FF6B8A]">Whop events are being rejected</b> · {a.count} failed signature check{a.count > 1 ? "s" : ""}, latest {shortDate(a.last_seen_at)}{a.hosts?.length ? ` (sent to ${a.hosts.join(", ")})` : ""}. An old Whop webhook is using a wrong secret.</span>
      <span className="font-mono text-[10px] tracking-widest text-[#FF6B8A]">FIX IN ERROR CENTER →</span>
    </Link>
  );
};
